var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',{staticClass:"loginLayout"},[(!_vm.person)?_c('div',[_c('button',{staticClass:"loginBtn loginBtn--google",on:{"click":function($event){_vm.logUserInGoogle()}}},[_vm._v("\n          Login with Google\n        ")])]):_vm._e(),_vm._v(" "),(_vm.person)?_c('div',[_c('span',[_vm._v("Welcome "+_vm._s(_vm.person.displayName)+" ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b9a906e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 462
// module chunks = 1